import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../api/adminApi";

export function useAdminOverviewQuery() {
  return useQuery({ queryKey: ["admin", "overview"], queryFn: adminApi.getOverview });
}
